// Component: IconGrid
// Author: Jay
import React from 'react';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import IconGridUI from '@component/IconGrid';

const IconGrid = ({ rendering }) => {
  return (
    <>
      <IconGridUI cards={<Placeholder name="Icon-Grid-Card" rendering={rendering} />}></IconGridUI>
    </>
  );
};

export default withSitecoreContext()(IconGrid);
